import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useRef, useState } from 'react'
import {
  LocationContent,
  MapContainerDiv
} from 'containers/event/map/MapContainer.style'
import Map from './Map'
import { StaticMap } from './StaticMap'

interface Props {
  longitude: number
  latitude: number
}

export const LocationContainer = ({ latitude, longitude }: Props) => {
  const [showDynamicMap, setShowDynamicMap] = useState(false)
  const [showStaticMap, setShowStaticMap] = useState(true)
  const { t } = useTranslation('event')
  const mapRef = useRef<HTMLDivElement>(null)
  return (
    <MapContainerDiv>
      <Typography variant="h4">{t('location')}</Typography>
      <LocationContent ref={mapRef}>
        {showDynamicMap && (
          <Map
            latitude={latitude}
            longitude={longitude}
            onLoad={() => setShowStaticMap(false)}
          />
        )}
        {showStaticMap && mapRef.current && (
          <StaticMap
            latitude={latitude}
            longitude={longitude}
            pointerEventsNone={showDynamicMap}
            onMouseDown={() => setShowDynamicMap(true)}
            mapRef={mapRef}
          />
        )}
      </LocationContent>
    </MapContainerDiv>
  )
}
